<template>
	<div class="mx-auto text-center pt-5" style="width: 100%;"><h4>Resource Not Found</h4></div>
</template>

<script>
export default {
	name: "NotFound"
}
</script>